import LoggedOutFooter from 'components/organisms/Footer/LoggedOutFooter'
import Header from 'components/organisms/Header'
import React from 'react'
import CenteredLayout from 'templates/CenteredLayout'

function Privacy() {
  return (
    <CenteredLayout
      HeaderComp={<Header title="Smart gym" subtitle="Privacy Policy" />}
      FooterComp={<LoggedOutFooter />}
      // CtaComp={<SignupCTA />}
      style={{ paddingBottom: 0 }}
    >
      <p>
        INFORMATIVA PER IL TRATTAMENTO DEI DATI PERSONALI EX ART. 13 D.LGS. 196
        / 20 0 3 - AR TT . 13 E 14 R E G O L AM E N T O UE 679 / 2 01 6 Ai sensi
        dell’art. 13 del D.lgs. n. 196 del 30 giugno 2003 ("Codice in materia di
        protezione dei dati personali") come modificato e integrato dagli artt.
        13 e 14 del Regolamento UE 679/2016 (“GDPR”) <br />
        <br />
        Le forniamo le seguenti informazioni a tutela del Suo diritto al
        trattamento dei dati personali secondo i principi di correttezza,
        liceità e trasparenza ed a garanzia della Sua riservatezza.
        <br />
        <br /> 1.TITOLARE DEL TRATTAMENTO. Il Titolare del Trattamento (di
        seguito anche solo “TITOLARE”) è la società SMART GYM(di Riccardo
        Sorghini) con sede in Bolonga via della Luna 1 40128, Codice Fiscale
        SRGRCR91B11A785O P.IVA 03760251201. Responsabile del Trattamento dati:
        Riccardo Sorghini e-mail:smartgymbologna@gmail.com <br />
        2. FINALITÀ DEL TRATTAMENTO. I dati da Lei forniti saranno trattati ai
        fini della corretta e completa esecuzione dell’incarico affidato .In
        particolare, l'attività SMART GYM opera nel settore del fitness. A tal
        fine la società richiede acquisisce ed utilizza informazioni e dati
        personali relativamente ai propri clienti, fornitori, dipendenti e
        collaboratori per una corretta e sicura gestione dei servizi offerti.
        <br />
        3. MODALITÀ DI TRATTAMENTO DEI DATI. Il trattamento sarà effettuato con
        le seguenti modalità: ▪Mediante supporti informatici; ▪Mediante supporti
        cartacei. Detti supporti sono custoditi esclusivamente presso gli uffici
        del TITOLARE, nel rispetto della normativa vigente, in particolare in
        materia di misure di sicurezza e riservatezza in conformità ai principi
        di correttezza, liceità , trasparenza e tutela dei diritti del cliente.
        <br />
        4. CONSEGUENZE DELLA MANCATA COMUNICAZIONE DEI DATI PERSONALI.
        L’eventuale rifiuto di fornire tali dati potrebbe comportare la mancata
        o parziale esecuzione del contratto ovvero l’impossibilità nella
        prosecuzione del rapporto. <br />
        5. CONSERVAZIONE DEI DATI PERSONALI. I Suoi dati personali, oggetto di
        trattamento per le finalità sopra indicate, saranno conservati per il
        periodo di durata del contratto e, successivamente, per il tempo in cui
        il TITOLARE sarà soggetto ad e v e n t u a l i obblighi di conservazione
        per finalità fiscali o per altre finalità previste da norme di legge o
        regolamento quindi, in genere, per 10 anni dalla data della cessazione
        del rapporto. <br />
        6. COMUNICAZIONE DEI DATI PERSONALI, PROFILAZIONE E DIFFUSIONE DEI DATI.
        I dati non saranno comunicati a terzi se non per l’adempimento degli
        obblighi connessi all’espletamento dell’incarico ricevuto o per
        imposizione di legge. Potranno quindi, ad esempio, essere comunicati a:
        ▪Soggetti che elaborano i dati in esecuzione di specifici obblighi di
        legge; -Commercialista; ▪Autorità giudiziarie o amministrative, per
        l’adempimento degli bblighi di legge. I Suoi dati personali non sono
        soggetti a diffusione né ad alcun processo decisionale interamente
        automatizzato, ivi compresa la profilazione. <br />
        7. DATI PARTICOLARI. Il trattamento potrà riguarderà anche dati
        personali rientranti nel novero dei Dati Particolari (ex “dati
        sensibili”), vale a dire dati idonei a rivelare l'origine razziale ed
        etnica, le convinzioni religiose, filosofiche o di altro genere, le
        opinioni politiche, l’adesione a partiti, sindacati, associazioni od
        organizzazioni a carattere religioso, filosofico, politico o sindacale,
        nonché i dati personali idonei a rivelare lo stato di salute e la vita
        sessuale. A riguardo la informiamo che il conferimento di questi dati è
        talvolta obbligatorio ai fini dell’esecuzione dell’incarico a noi
        conferito nonché ottemperare agli obblighi di legge. L’eventuale rifiuto
        a fornirli potrebbe infatti comportare la mancata o parziale esecuzione
        del contratto ovvero la mancata prosecuzione del rapporto. <br />
        8. SISTEMA DI VIDEOSORVEGLIANZA Per esigenze di sicurezza nei locali è
        stato predisposto un sistema di videosorveglianza in funzione 24 ore su
        24. Gli impianti e le apparecchiature esistenti non potranno riprendere
        i luoghi riservati alla zona spogliatoio, né essere utilizzati per il
        controllo a distanza dell’attività svolta all’interno dei locali. Il
        trattamento dei dati derivanti dall’attività di videosorveglianza,
        avverrà nel rispetto delle garanzie previste dalla normativa vigente,
        nel rispetto dei diritti e delle libertà degli utenti, con particolare
        riferimento alla riservatezza, all’identità ed alla protezione dei dati
        personali. Il trattamento dei dati derivanti dall’attività di
        videosorveglianza è eseguito attraverso procedure informatiche; i dati
        saranno conservati per un periodo massimo di ore 24, con successiva
        cancellazione automatica. <br />
        9. DIRITTI DELL’INTERESSATO. In ogni momento potrà esercitare i diritti
        riconosciutale dal GDPR (artt. da 15 a 22) tra cui quelli diretti a: ▪
        richiedere al TITOLARE l’accesso ai Suoi dati personali ed alle
        informazioni relative agli stessi; la rettifica dei dati inesatti o
        l'integrazione di quelli incompleti; la cancellazione dei dati personali
        che la riguardano (al verificarsi di una delle condizioni indicate
        nell'art. 17, paragrafo 1 del GDPR e nel rispetto delle eccezioni
        previste nel paragrafo 3 dello stesso articolo); la limitazione del
        trattamento dei Suoi dati personali (al ricorrere di una delle ipotesi
        indicate nell'art. 18, paragrafo 1 del GDPR); ▪ opporsi in qualsiasi
        momento al trattamento dei Suoi dati personali al ricorrere di
        situazioni particolari che la riguardano; ▪ revocare il consenso in
        qualsiasi momento, limitatamente alle ipotesi in cui il trattamento sia
        basato sul Suo consenso per una o più specifiche finalità e riguardi
        dati personali comuni oppure particolari. Il trattamento basato sul
        consenso ed effettuato antecedentemente alla revoca dello stesso
        conserva, comunque, la sua liceità; ▪ proporre reclamo a un'autorità di
        controllo (Autorità Garante per la protezione dei dati personali – ww w.
        g a r a n te pr i v a c y. i t). In merito all'esercizio di tali diritti
        lei potrà rivolgersi al TITOLARE: SMART GYM(Riccardo Sorghini) con sede
        in Bolonga via della Luna 1 40128, Codice Fiscale SRGRCR91B11A785O P.IVA
        03760251201. inviando una raccomandata A.R. all’indirizzo Via della Luna
        1 40128 BO ovvero una e-mail: smartgymbologna@gmail.com
        <br />
        <br />
      </p>
    </CenteredLayout>
  )
}

export default Privacy
